export const getIndexFromID = (id, questions) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < questions.length; i++) if (questions[i].id === id) return i;
  return 0;
};
